import React from 'react';

const StatusRouter = ({ children }) => {
  // This component would handle routing based on user setup status
  // For now, just render children
  return children;
};

export default StatusRouter;